import { render, staticRenderFns } from "./addInvoice.vue?vue&type=template&id=3d4b1255&scoped=true&"
import script from "./addInvoice.vue?vue&type=script&lang=js&"
export * from "./addInvoice.vue?vue&type=script&lang=js&"
import style0 from "./addInvoice.vue?vue&type=style&index=0&id=3d4b1255&prod&scoped=true&lang=css&"
import style1 from "./addInvoice.vue?vue&type=style&index=1&id=3d4b1255&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4b1255",
  null
  
)

export default component.exports